import {
    CREATE_ACCESSORIES_PO_DETAILS_REQUEST_DK,
    CREATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK,
    CREATE_ACCESSORIES_PO_DETAILS_FAILURE_DK,
    DELETE_ACCESSORIES_PO_DETAILS_REQUEST_DK,
    DELETE_ACCESSORIES_PO_DETAILS_SUCCESS_DK,
    DELETE_ACCESSORIES_PO_DETAILS_FAILURE_DK,
    FETCH_SINGLE_ACCESSORIES_PO_DETAILS_REQUEST_DK,
    FETCH_SINGLE_ACCESSORIES_PO_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_ACCESSORIES_PO_DETAILS_FAILURE_DK,
    FETCH_ACCESSORIES_PO_DETAILS_REQUEST_DK,
    FETCH_ACCESSORIES_PO_DETAILS_SUCCESS_DK,
    FETCH_ACCESSORIES_PO_DETAILS_FAILURE_DK,
    UPDATE_ACCESSORIES_PO_DETAILS_REQUEST_DK,
    UPDATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK,
    UPDATE_ACCESSORIES_PO_DETAILS_FAILURE_DK,
    RESET_ACCESSORIES_PO_DETAILS_INFO_DK,
    CREATE_ACCESSORIES_PO_DETAILS_FORM_DK,
    UPDATE_ACCESSORIES_PO_DETAILS_FORM_DK,
    FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_REQUEST_DK,
    FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_SUCCESS_DK,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST_DK,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE_DK,
    FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS_DK
 
    
} from './accessoriesPoDetails.actionsType';

export const ACCESSORIES_PO_DETAILS_DK = 'accessoriesPoDetailsDK';

let initialState = {
    loading: false,
    accessoriesPoDetails: [],
    accessoriesPoDetailsWithoutId: [],
    groupList: [],
    accessoriesPoDetailsForm: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    previousList: [],
    selectedState: {},
    errorMessage: ''
};

export let accessoriesPoDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ACCESSORIES_PO_DETAILS_REQUEST_DK:
        case CREATE_ACCESSORIES_PO_DETAILS_REQUEST_DK:
        case UPDATE_ACCESSORIES_PO_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_ACCESSORIES_PO_DETAILS_REQUEST_DK:
        case DELETE_ACCESSORIES_PO_DETAILS_REQUEST_DK:
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_REQUEST_DK:
        case FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCESSORIES_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetails: updatePayload
            };
           
           
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousList: updatePayload
            };
        case FETCH_ACCESSORIES_PO_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetailsWithoutId: updatePayload
            };
           
        case FETCH_ACCESSORIES_PO_DETAILS_GROUP_LIST_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                groupList: updatePayload
            };
        case CREATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                grnNoByAccessoriesPO:[]
            };
        case UPDATE_ACCESSORIES_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case FETCH_SINGLE_ACCESSORIES_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetailsForm: updatePayload
            };
        case DELETE_ACCESSORIES_PO_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case RESET_ACCESSORIES_PO_DETAILS_INFO_DK:
            return {
                ...state,
                accessoriesPoDetailsForm: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case CREATE_ACCESSORIES_PO_DETAILS_FORM_DK:
        case UPDATE_ACCESSORIES_PO_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                accessoriesPoDetailsForm: {
                    ...state.accessoriesPoDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_ACCESSORIES_PO_DETAILS_FAILURE_DK:
        case CREATE_ACCESSORIES_PO_DETAILS_FAILURE_DK:
        case UPDATE_ACCESSORIES_PO_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_ACCESSORIES_PO_DETAILS_FAILURE_DK:
        case DELETE_ACCESSORIES_PO_DETAILS_FAILURE_DK:
        case FETCH_ACCESSORIES_PO_PREVIOUS_LIST_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
